import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { fmtCurrency, fmtNumber, fmtPct, fmtDecimal } from "@/lib/format";

export function KpiCard({ label, value, sub, tone = "default", testId }) {
  const toneClass =
    tone === "positive" ? "text-green-700" : tone === "negative" ? "text-[#DC2626]" : "text-gray-950";
  return (
    <Card className="rounded-sm border-gray-200 shadow-none" data-testid={testId}>
      <CardContent className="p-6 md:p-7">
        <div className="text-[10px] uppercase tracking-[0.25em] text-gray-500 font-bold">{label}</div>
        <div className={`mt-3 font-display font-black text-3xl md:text-4xl tracking-tighter ${toneClass}`}>
          {value ?? "—"}
        </div>
        {sub ? <div className="mt-2 text-xs text-gray-500 font-mono-metric">{sub}</div> : null}
      </CardContent>
    </Card>
  );
}

export const formatters = { fmtCurrency, fmtNumber, fmtPct, fmtDecimal };
